










import { defineComponent, PropType } from "@vue/composition-api";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import { getProfileUrl } from "@/lib/urlHelpers";
import BaseAvatar from "@/components/BaseAvatar";

export default defineComponent({
  name: "ProviderInfo",
  methods: { getProfileUrl },
  components: { BaseAvatar },
  props: {
    provider: { type: Object as PropType<UserPublicData>, required: true },
    itemsCount: { type: Number, default: 0 },
  },
});
